import {Injectable, SecurityContext} from '@angular/core';
import {DomSanitizer} from "@angular/platform-browser";

@Injectable({
  providedIn: 'root'
})
export class SanitizeService {

  SecurityContext = SecurityContext;

  public escapeRegex: RegExp = /[&<>"']/g;


  public escapeEntities: { [x: string]: string } = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&#34;',
    '\'': '&#39;'
  };

  public escapeAngleRegex: RegExp = /[<>]/g;

  public escapeAngleEntities: { [x: string]: string } = {
    '<': '&lt;',
    '>': '&gt;',
  };

  constructor(private sanitizer: DomSanitizer) {
    (window as any).NG_SHARED_SANITIZE_SERVICE = this;
    (window as any).Sanitize = this;
  }

  sanitize(context: SecurityContext, source: string): string {
    const c = arguments.length == 2 ? context : SecurityContext.HTML;
    const s = arguments.length == 2 ? source : context;

    return this.sanitizer.sanitize(c, s);
  }

  sanitizeNone(source: string): string {
    return this.sanitize(SecurityContext.NONE, source);
  }

  sanitizeHtml(source: string): string {
    return this.sanitize(SecurityContext.HTML, source);
  }

  sanitizeStyle(source: string): string {
    return this.sanitize(SecurityContext.STYLE, source);
  }

  sanitizeScript(source: string): string {
    return this.sanitize(SecurityContext.SCRIPT, source);
  }

  sanitizeUrl(source: string): string {
    return this.sanitize(SecurityContext.URL, source);
  }

  sanitizeResourceUrl(source: string): string {
    return this.sanitize(SecurityContext.RESOURCE_URL, source);
  }

  private escape(value: any): any {
    // Use this to make content that looks like HTML display as escaped
    return value?.replace(this.escapeRegex, (c: string) => {
      return this.escapeEntities[c];
    });
  }

  private escapeAngleBrackets(value: any): any {
    // Use this to make content that looks like HTML display as escaped, but only for the angle brackets
    return value?.replace(this.escapeAngleRegex, (c: string) => {
      return this.escapeAngleEntities[c];
    });
  }

}
